import { createSelector } from 'reselect';

export const appealCancelDataSelector = state => state.appealCancelData;

export const appealCancelDataLoadingSelector = createSelector(
  appealCancelDataSelector,
  subState => subState.loading
);

export const appealCancelDataErrorSelector = createSelector(
  appealCancelDataSelector,
  subState => subState.error
);

export const appealCancelDataSuccessSelector = createSelector(
  appealCancelDataSelector,
  subState => subState.success
);
